import * as React from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import '../css/info.css'
import {getFont} from '../util/util'

const InfoBlock = () => {
    const {t, i18n} = useTranslation('footer')
    return (
        <div className="info-container" style={getFont(i18n)}>
            <div className="info">
                <span className="not-tablet not-mobile"><a href="mailto:info@persona.ly">INFO@PERSONA.LY</a></span>
                <span className="not-tablet not-mobile">+1-888-724-8205</span>
                <span className="not-mobile"><Link to="privacy_policy">{t('privacy policy')}</Link></span>
                <span className="not-mobile"><Link to="terms_use">{t('terms of use')}</Link></span>
                <span>
                    {t('all rights 1')}
                    {new Date().getFullYear()}
                    {t('all rights 2')}
                </span>
            </div>
        </div>
    )
}

export default InfoBlock


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/infoBlock.tsx